module.exports = __webpack_public_path__ + "img/textarea-resize.e50baea2.svg";